export const WIRES_WORKFLOW_CONTAINER_TAG_NAME = 'wires-workflow-container';
export const JH_WIRES_WORKFLOW_CONTAINER_TAG_NAME = 'jh-wires-workflow-container';
